type StatusKey = 'pending' | 'paid' | 'cancelled'

export interface StatusInfo {
  text: string
  color: string
}

export function payment(status: string): StatusInfo {
  const statuses: Record<StatusKey, StatusInfo> = {
    pending: { text: 'Pendente', color: 'orange' },
    paid: { text: 'Pago', color: 'green' },
    cancelled: { text: 'Cancelado', color: 'red' },
  }

  const key = status.toLowerCase() as StatusKey

  return statuses[key] || { text: 'Desconhecido', color: 'gray' }
}
